import { useState } from 'react'
import { toast } from 'react-toastify'

import { Button } from '../../../../../../../components/Button'
import { type SkillsFieldsValues, SkillsForm } from './components/SkillsForm'
import { Spinner } from '../../../../../../../components/Spinner'
import { getErrorMessage } from '../../../../../../../utils/getErrorMessage'
import {
  TOAST_ERROR_DEFAULT_OPTIONS,
  TOAST_SUCCESS_DEFAULT_OPTIONS,
} from '../../../../../../../constants/toast'
import { useExpertQuery } from '../../../../../../../services/hooks/experts/queries/useExpertQuery'
import { useExpertMutation } from '../../../../../../../services/hooks/experts/mutations/useExpertMutation'

interface Props {
  id?: string
}

export const SkillsData = ({ id }: Props) => {
  const [isEditing, setIsEditing] = useState(false)

  const { data: expert, isLoading: isLoadingExpert } = useExpertQuery(
    Number(id)
  )

  const { mutate: updateExpert, isLoading: isUpdatingExpertSkills } =
    useExpertMutation(Number(id))

  const handleUpdateSkills = (data: SkillsFieldsValues) => {
    updateExpert(
      { id: Number(id), data },
      {
        async onSuccess() {
          toast.success(
            'Habilidades salvas com sucesso',
            TOAST_SUCCESS_DEFAULT_OPTIONS
          )
          setIsEditing(false)
        },
        onError(error) {
          toast.error(getErrorMessage(error), TOAST_ERROR_DEFAULT_OPTIONS)
        },
      }
    )
  }

  if (isLoadingExpert) {
    return <Spinner />
  }

  return (
    <div>
      <div className="flex flex-col gap-14">
        <div className="flex flex-col gap-4">
          <p className="font-medium text-grey-700">Skills da área: </p>
          <div className="flex flex-col gap-4">
            {expert?.areaSkills?.map((result: any) => (
              <p key={result.id}>{result.portugueseName}</p>
            ))}
          </div>
        </div>

        <div className="flex flex-col gap-4">
          <p className="font-medium text-grey-700">Skills de domínio: </p>
          <div className="flex flex-col gap-4">
            {expert?.domainSkills?.map((result: any) => (
              <p key={result.id}>{result.portugueseName}</p>
            ))}
          </div>
        </div>
        
        <div className="flex flex-col gap-4">
          <p className="font-medium text-grey-700">Idiomas de reunião: </p>
          <div className="flex flex-col gap-4 mb-14">
            {expert?.meetingLanguages?.join(', ')}
          </div>
        </div>
      </div>

      {isEditing && (
        <div className="flex flex-col gap-4 mb-10 max-w-[610px]">
          <SkillsForm
            defaultValues={expert as any}
            onSubmit={handleUpdateSkills}
            isSubmitting={isUpdatingExpertSkills}
          />
        </div>
      )}

      {!isEditing && (
        <Button
          className="py-1"
          variant="outline"
          onClick={() => setIsEditing((prevState) => !prevState)}
        >
          Editar
        </Button>
      )}
    </div>
  )
}
